export default __webpack_public_path__ + "static/animatedIntro-1080-ef6a08575cc7df40f907a1b568835294.mp4";